import * as _ from 'lodash';
import UploadModelService, { IMapping } from './uploadModel.service';

function mapColumns(columnMappings) {
  return _.map(columnMappings, (mapping: IMapping) => {
    return {
      columnHeader: mapping.headerName,
      mapFieldName: mapping.columnName
    };
  });
}

class SummaryPaneCtrl {
  static bindings = {
    uploadApi: '<',
    featureList: '<'
  };

  uploadApi;
  featureList;

  state;
  searchResults;
  selectedWorksheet;
  unsubscribeFromStore;

  importMatchedCount;
  importNotMatchedCount;
  unorderedPricingCount;

  constructor(private UploadModel: UploadModelService) {
    'ngInject';
  }

  $onInit() {
    this.state = this.UploadModel.store.getState();
    this.selectedWorksheet = this.UploadModel.getSelectedWorksheet(this.state);

    this.unsubscribeFromStore = this.UploadModel.store.subscribe(() => {
      this.state = this.UploadModel.store.getState();
      this.selectedWorksheet = this.UploadModel.getSelectedWorksheet(
        this.state
      );
    });

    if (_.get(this.state.file, 'uploadId')) {
      if (this.UploadModel.isTabComplete('columns')) {
        let mappings = mapColumns(
          _.get(this.selectedWorksheet, 'columnMappings')
        );

        let data = {
          fileUploadId: this.state.file.uploadId,
          sheetName: this.selectedWorksheet.name,
          fields: mappings,
          headerIndex: this.selectedWorksheet.headers.rowIndex
        };

        this.uploadApi.search(data).then((searchResults) => {
          // Set this for the import success message which gets transcluded
          this.importMatchedCount = searchResults.recordMatchedCount;
          this.importNotMatchedCount = searchResults.recordViolationCount;
          this.unorderedPricingCount = searchResults.unorderedPricingCount;
          
          this.searchResults = searchResults;
          let action = this.UploadModel.updateSearchResults(searchResults);
          this.UploadModel.store.dispatch(action);
        });
      }
    }
  }

  $onDestroy() {
    this.unsubscribeFromStore();
  }

  canSearchProducts() {
    return this.UploadModel.canSearchProducts(this.state);
  }

  getDownloadUrl() {
    if (this.state.searchResults) {
      return `${this.uploadApi.appRoot}/api${this.state.searchResults.downloadUrl}`;
    }
  }
}

export const SummaryPaneComponent = {
  bindings: SummaryPaneCtrl.bindings,
  template: require('./summaryPane.component.html'),
  controller: SummaryPaneCtrl,
  transclude: {
    importingDescription: '?importingDescription',
    notImportingDescription: '?notImportingDescription'
  }
};
